import api from './api.js';
import { Navigation } from './scripts/navigation/navigation';

api.Navigation = Navigation;

export default api;
